import { render, staticRenderFns } from "./OnlCgformTabList.vue?vue&type=template&id=173f9c79&scoped=true&"
import script from "./OnlCgformTabList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformTabList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformTabList.vue?vue&type=style&index=0&id=173f9c79&scoped=true&lang=css&"
import style1 from "./OnlCgformTabList.vue?vue&type=style&index=1&id=173f9c79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173f9c79",
  null
  
)

export default component.exports